import { Injectable } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FloorService {

    constructor(private _http: HttpClient) { }
    getAllfloor(obj: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Floor/FilterWithDetails' ;
        return this._http.post(url, obj);
    }

    


    addfloor(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'floor/Create';
        return this._http.post(url, request);
    }

    


    getDeviceDropdown(): Observable<any> {
        const url = GlobalConstants.API_URL + 'Device/GetAllForDropDown';
        return this._http.get(url);
    }

    getFloorDropdown(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Floor/GetAllForDropDown';
        return this._http.get(url);
    }
    
    deletefloor(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + `floor/Delete?id=` + request;  
        return this._http.delete(url, request);
    }

    update(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'floor/Update?id=' + request.id;
        return this._http.put(url, request);
    }


}